<template>
  <sPopover
    v-model="visible"
    width="200">
    <sButton
      slot="reference"
      :class="className"
      :disabled="disabled"
      icon="menu"
      small
      type="text"/>
    <div>
      <MenuItem
        v-if="!disableClone"
        data-qa="menu-copy-item"
        :disabled="disabled"
        icon="repeat"
        :label="$t('Catalog.Duplicate')"
        @click="sendEvent('copyItem')"/>
      <MenuItem
        data-qa="menu-delete-item"
        :disabled="disabled"
        icon="delete"
        :label="$t('Purchasing.Remove')"
        @click="sendEvent('cancelSelection')"/>
    </div>
  </sPopover>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'

export default {
  name: 'rowMenu',
  data() {
    return {
      visible: false
    }
  },
  methods: {
    sendEvent(event) {
      this.$emit(event)
      this.visible = false
    },
  },
  props: {
    className: String,
    disableClone: Boolean,
    disabled: Boolean
  },
  components: {
    MenuItem
  }
}
</script>
